import * as React from "react";

function SvgClose16Px(props) {
  return <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M7.58 6.5l5.2-5.19a.79.79 0 000-1.09.79.79 0 00-1.09 0L6.5 5.42 1.31.22a.79.79 0 00-1.09 0 .79.79 0 000 1.09l5.2 5.19-5.2 5.19a.79.79 0 000 1.09.77.77 0 00.55.22.76.76 0 00.54-.22l5.19-5.2 5.19 5.2a.79.79 0 001.09 0 .79.79 0 000-1.09z" fill="currentColor" /></svg>;
}

export default SvgClose16Px;